<template>
  <section class="section">
    <b-loading :active="$apollo.loading"></b-loading>
    <div class="container" v-if="application">
      <div class="columns">
        <div class="column is-one-fifth">
          <figure class="media-left">
            <p class="image is-96x96">
              <img class="is-rounded" :src="application.photo || noPhotoSrc">
            </p>
          </figure>
        </div>
        <div class="column">
          <h2 class="title is-3">
            {{ application.name }}
          </h2>
          <div v-if="application.instagram">
            <span class="icon has-text-danger is-small"><i class="fab fa-instagram"></i></span>
            <template v-if="application.instagramFollowers">
              {{ application.instagramFollowers }} followers |
            </template>
            {{ application.instagram }}
          </div>
        </div>
      </div>
      <div class="details-columns">
        <div class="columns">
          <div class="column is-one-fifth">Name</div>
          <div class="column">{{ application.name }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Phone</div>
          <div class="column">{{ application.phone }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Email</div>
          <div class="column">{{ application.email }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Zip Code</div>
          <div class="column">{{ application.zip_code }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Certifications</div>
          <div class="column">{{ application.certifications }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Specialities</div>
          <div class="column">{{ application.specialties }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Years of Experiences</div>
          <div class="column">{{ application.yearsOfExperience }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Experiences</div>
          <div class="column">{{ application.experience }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Training Hourly Rate</div>
          <div class="column">{{ application.hourlyRate }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Current Classes</div>
          <div class="column">{{ application.classes }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Bio/Statement</div>
          <div class="column">{{ application.bio }}</div>
        </div>
      </div>

      <div class="columns" v-if="application.video">
        <div class=" is-offset-one-fifth column">
          <video width="500" controls>
            <source :src="application.video">
            Your browser does not support HTML5 video.
          </video>
        </div>
      </div>

      <hr>
      <h5 class="title is-5">Notes:</h5>
      <div class="columns" v-for="(applicationNote,index) in application.applicationNotes" :key="applicationNote.id+'-'+index">
        <div class="column is-one-fifth"><p>{{ applicationNote.createdAt | moment("  MMMM DD, YYYY ") }}</p></div>
        <div class="column">
          <p>
            {{ applicationNote.note }}
            <br>
            <small><em>-{{ applicationNote.user.name }}</em></small>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class=" is-offset-one-fifth column">
          <form @submit.prevent="createNotes">
            <b-field>
              <b-input is-medium maxlength="100" type="textarea" v-model="note"></b-input>
             </b-field>
            <button type="submit" class="button is-primary">Submit</button>
          </form>
        </div>
      </div>
      <hr>
      <div class="columns" v-if="!isApproved && !isRejected">
        <div class="buttons">
          <button class="button is-success" @click="openManageModal(application)">Approve Trainer</button>
          <button class="button is-danger is-outlined" @click="openRejectModal(application)">Reject Trainer</button>
        </div>
      </div>
      <div class="columns" v-if="isRejected">
        <div class="buttons">
          <button class="button is-danger is-outlined is-disabled" disabled>Rejected {{ application.rejectedAt | moment("  MMMM DD, YYYY ") }}</button>
          <button class="button is-danger" @click="unrejectApplication(application)">Un-Reject Trainer</button>
        </div>
      </div>
      <div class="columns" v-if="isApproved">
        <div class="buttons">
          <button class="button is-success is-outlined is-disabled" disabled>Approved {{ application.approvedAt | moment("  MMMM DD, YYYY ") }}</button>
        </div>
      </div>
    </div>
    <approve-manage-modal :applicant="application" ref="manageModal" @handleClose="closeManageModal()"></approve-manage-modal>
    <reject-manage-modal  :applicant="application" ref="rejectModal" @handleClose="closeManageModal()"></reject-manage-modal>
  </section>
</template>

<script>
import { applicationQuery, createApplicationNoteMutation, unrejectApplicationMutation } from '../../graphql/applications'
import ApproveManageModal from './ApproveManageModal.vue'
import RejectManageModal from './RejectManageModal.vue'

export default {
  name: 'ApplicantDetails',
  components: {
    ApproveManageModal,
    RejectManageModal
  },
  data () {
    return {
      note: '',
      noPhotoSrc: 'https://dummyimage.com/400x400/000/fff.jpg&text=No+Photo'
    }
  },
  apollo: {
    application: {
      query: applicationQuery,
      variables () {
        return {
          id: this.id
        }
      },
      fetchPolicy: 'network-only'
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    isApproved () {
      return !!this.application.approvedAt
    },
    isRejected () {
      return !!this.application.rejectedAt
    }
  },
  methods: {
    // open the modal to manage a user
    openManageModal (application) {
      this.$refs.manageModal.$refs.modal.open()
    },
    openRejectModal (application) {
      this.$refs.rejectModal.$refs.modal.open()
    },
    closeManageModal (id) {
      this.$refs.manageModal.$refs.modal.close()
      this.$refs.rejectModal.$refs.modal.close()
    },
    createNotes () {
      this.$apollo.mutate({
        mutation: createApplicationNoteMutation,
        variables: {
          applicationId: this.id,
          note: this.note
        }
      })
        .then(() => {
          this.refetchApplication()
          // reset the form
          this.note = ''
        })
        .catch((e) => {
          this.$toast.open({
            message: 'Error: ' + e.message,
            type: 'is-danger',
            duration: 5000
          })
        })
    },
    unrejectApplication (application) {
      this.$dialog.confirm({
        message: 'Are you sure you want to un-reject this application? This will return it to the "Pending" state.',
        onConfirm: () => {
          this.$apollo.mutate({
            mutation: unrejectApplicationMutation,
            variables: {
              id: this.id
            }
          })
            .then(() => {
              this.refetchApplication()
              this.$toast.open({
                message: 'Application has been un-rejected',
                type: 'is-success'
              })
            })
            .catch((e) => {
              this.$toast.open({
                message: 'Error: ' + e.message,
                type: 'is-danger',
                duration: 5000
              })
            })
        }
      })
    },
    // refetch the applications after the contents may have changed
    refetchApplication () {
      this.$apollo.queries.application.refetch()
    }
  }
}
</script>
